<template>
     <div class="col-lg-6 text-start">
                  <div class="card">
                    <div class="card-header pb-0">
                      <h3>Sizing</h3>
                    </div>
                    <div class="card-body avatar-showcase">
                      <div class="avatars">
                        <div class="avatar"><img class="img-100 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-90 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-80 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-70 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-60 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-50 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-40 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-30 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                        <div class="avatar"><img class="img-20 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 text-start">
                  <div class="card">
                    <div class="card-header pb-0">
                      <h3>Status Indicator</h3>
                    </div>
                    <div class="card-body avatar-showcase">
                      <div class="avatars">
                        <div class="avatar"><img class="img-100 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-100 bg-primary"> </div>
                        </div>
                        <div class="avatar"><img class="img-90 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-90 bg-primary"></div>
                        </div>
                        <div class="avatar"><img class="img-80 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-80 bg-primary"></div>
                        </div>
                        <div class="avatar"><img class="img-70 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-70 bg-primary"></div>
                        </div>
                        <div class="avatar"><img class="img-60 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-60 bg-primary"></div>
                        </div>
                        <div class="avatar"><img class="img-50 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-50 bg-primary"> </div>
                        </div>
                        <div class="avatar"><img class="img-40 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-40 bg-primary"></div>
                        </div>
                        <div class="avatar"><img class="img-30 rounded-circle" src="../../../assets/images/user/1.jpg" alt="#">
                          <div class="status status-30 bg-primary"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 text-start">
                  <div class="card">
                    <div class="card-header pb-0">
                      <h3>Initials</h3>
                    </div>
                    <div class="card-body avatar-showcase">
                      <div class="avatars">
                        <div class="avatar"><img class="img-100 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-90 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-80 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-70 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-60 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-50 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-40 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-30 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-20 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                        <div class="avatar"><img class="img-10 rounded-circle" src="../../../assets/images/user/16.png" alt="#"></div>
                      </div>
                    </div>
                  </div>
                </div>
                
</template>